


import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { CommunicationMessageTypes } from "../../../../../shared/enum-files/general-enums";
import { ShareConfigService } from "../../../../../shared/services/shareConfig.service";
import { FroalaEditorOptions } from "../../../../../shared/services/template-froala-options";
import { VariablePopupService } from "../../../../../shared/services/variable-popup.service";


@Component({
  selector: 'app-subject-template',
  templateUrl: './subject-template.component.html',
  styleUrls: ['./subject-template.component.scss']
})

export class SubjectTemplateComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() notificationType:any;
  @Output() changeSubject = new EventEmitter();

  // Template Editor Froala
  public froalaEditorOptions = new FroalaEditorOptions();
  public setEditorOptions: object;
  public allowedVariblesFor: string = 'appointment';

  public isSubjectVariablesPopupEnabled: boolean = false;


  constructor(private variablePopupService: VariablePopupService,private shareConfigService: ShareConfigService) { }


  ngOnInit() {
    this.setEditorOptions = this.froalaEditorOptions.setEditorOptions();
    this.setEditorOptions['toolbarButtons'] = ['my_dropdown'];
    this.froalaEditorOptions.customPopupBtn();
  }

  openVariablePopupSms() {
    this.isSubjectVariablesPopupEnabled = true;
    let variablePopupPayload: any = {};
    let msg = this.froalaEditorOptions.editorRefernce.html.get();
    // variablePopupPayload.listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObj(msg);
    variablePopupPayload.listOfUsedVariableObj = this.variablePopupService.getListOfUsedVariableObjV3(msg);
    variablePopupPayload.allowedVariblesFor = this.allowedVariblesFor;
    variablePopupPayload.isOpenPopup = true;
    variablePopupPayload.communicationType = "smsMsg";
    this.variablePopupService.variablePopupOpened = 'sms';
    this.variablePopupService.variablePopupPayload = variablePopupPayload;
    this.variablePopupService.changeInVariablePopupPayload();
  }

  subjectChange(data) {
    if(!this.shareConfigService.listOfUsedVariableObj[this.notificationType]){
      this.shareConfigService.listOfUsedVariableObj[this.notificationType] = {};
    }
    this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.SubjectTemplateMsg] = this.variablePopupService.getListOfUsedVariableFormulasInMsg(data);
    this.changeSubject.emit(data);
    this.isSubjectVariablesPopupEnabled = false;
  }

  UpdatePopUpStatus(e) {
    // let smsText = this.variablePopupService.insertFormulaIntoEditor(this.variablePopupService.listOfUsedVariableObj, this.froalaEditorOptions);
    let subject = this.variablePopupService.insertFormulaIntoEditorV3(this.variablePopupService.listOfUsedVariableObj, this.froalaEditorOptions);
    this.form.patchValue({ Subject: subject });
    this.changeSubject.emit(subject);
    this.isSubjectVariablesPopupEnabled = false;
    if(!this.shareConfigService.listOfUsedVariableObj[this.notificationType]){
      this.shareConfigService.listOfUsedVariableObj[this.notificationType] = {};
    }
   
    this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.SubjectTemplateMsg] = [];
    if(this.variablePopupService.listOfUsedVariableObj && this.variablePopupService.listOfUsedVariableObj.length > 0){
      this.variablePopupService.listOfUsedVariableObj.map((item:any) => {
        this.shareConfigService.listOfUsedVariableObj[this.notificationType][CommunicationMessageTypes.SubjectTemplateMsg].push(item.formula);
      })
    }
  }

  CancelPopUpStatus(e){
    this.isSubjectVariablesPopupEnabled = false;
  }

}


// WEBPACK FOOTER //
// ./src/app/appointments/appointment-types/add-appointment-type/messages/subject-template/subject-template.component.ts